import React from 'react'
import { NavLink } from "react-router-dom";

const NavBar = () => {
  return (
    <nav>
      <ul className='navbar'>
        <li>
          <NavLink to="/Games">Games</NavLink>
        </li>
        <li>
          <NavLink to="/Movies">Movies</NavLink>
        </li>
        <li>
          <NavLink to="/Series">Series</NavLink>
        </li>
        <li>
          <NavLink to="/Books">Books</NavLink>
        </li>
        <li>
          <NavLink to="/pokemon">Pokémon</NavLink>
        </li>
      </ul>
    </nav>
  );
};



export default NavBar
